export default function Header({ pageName, lastUpdate }) {
  return (
    <div>
      <h1 className="text-primary sm:text-6xl text-4xl font-semibold">
        {pageName}
      </h1>
      <p className="translate-x-1 -translate-y-0.5 text-xs opacity-60">
        Ultima actualizare: {lastUpdate}
      </p>

      <hr className="mt-2" />
    </div>
  )
}
